import React from 'react';
import PropTypes from 'prop-types';
import MLButton from '../../../../../../components/MLButton';
import styles from './QQTimeVsScoreCalcInfo.module.css';
import { WIDGET_TYPE_COMPLETED_ASSIGNMENT } from '../../../../constants';

const AssignmentCompletedInfo = () => (
    <>
      <ul>
        <li><span className={styles.infoPoint}>Did not open</span>: The number of students who have not yet launched the assignment.</li>
        <li><span className={styles.infoPoint}>Opened without starting</span>: The number of students who launched the assignment but did not answer a question.</li>
        <li><span className={styles.infoPoint}>In progress</span>: The number of students who have launched the assignment and attempted at least one question but are not yet considered completed.
          <ul>
            <li>Note: For assessments, students who do not complete assignments by the due date remain in the In progress category.</li>
          </ul>
        </li>
        <li><span className={styles.infoPoint}>Completed</span>: Number of students who have completed the assignment.
          <ul>
            <li>LearningCurve: Completion is defined as reaching the target score at any time (before or after the due date).</li>
            <li>{`Assessments: Completion is defined as attempting each question in the assignment at least once before the due date or selecting the "Submit All" button when available.`}</li>
          </ul>
        </li>
      </ul>
    </>
  );

const DefaultInfo = () => (
    <>
      <p>
        The total time for an assignment is calculated by adding up all the time the student spends interacting with that assignment from start to finish. We “stop the clock” any time the student doesn’t perform any action on the activity for about 10 minutes.
      </p>
      <p>
        Note that activity averages (scores and time) only included students that completed the activity. If a student did not complete the activity, their data is not included in this chart. Therefore, there may be some differences in the averages shown here and what you see in the Gradebook.
      </p>
    </>
  );

const renderInfoMap = {
  [WIDGET_TYPE_COMPLETED_ASSIGNMENT]: <AssignmentCompletedInfo />,
};

function QQTimeVsScoreCalcInfo({ back, widgetType }) {
  const renderInfo = renderInfoMap[widgetType] ?? <DefaultInfo />;
  return (
    <div className={styles.info}>
      <div>
        <h3 className={styles.title}>How was this insight calculated?</h3>
        {renderInfo}
      </div>
      <div className={styles.infoButton}>
        <MLButton
          data-id="__add_cancel_TimeScore_info"
          btnType="primary"
          type="submit"
          btnText="Back"
          testId="add_widget_btn"
          onClick={back}
        />
      </div>
    </div>
  );
}

export default QQTimeVsScoreCalcInfo;

QQTimeVsScoreCalcInfo.propTypes = {
  back: PropTypes.func,
};
